import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vuetify';
import VeeValidate from 'vee-validate';
import './plugins/vuetify';
import App from './App.vue';
import router from '@/router/index';
import store from './store/index';
import AuthManager from './auth';
import './registerServiceWorker';
import Error from '@/views/Error.vue';
import UserNotFound from '@/views/UserNotFound.vue';
import 'vue-orgchart/dist/style.min.css';
import { IProfileModel } from '@/models/Common';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(VeeValidate);
Vue.config.productionTip = false;

AuthManager.Instance.initialize().then(() => {
  store.dispatch('AppStore/getUserProfile').then((response: IProfileModel) => {
    if (response.empId === null) {
      Vue.prototype.$eventBus = new Vue({
        router,
        store,
        render: (h) => h(UserNotFound),
      }).$mount('#app');
    } else {
      Vue.prototype.$eventBus = new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount('#app');
    }
  }, () => {
    new Vue({
      router,
      store,
      render: (h) => h(Error),
    }).$mount('#app');
  });
});

